<template lang="pug">
div(v-if="cadastroFormulario.imovel")
  el-row.labelDiv(:gutter="30" v-if="tipoCadastro && tipoCadastro !== 'ONEROSO'")
    validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Possui Car'")
      app-label(label="Possui CAR ?", :required="true" name="Imovel" )
      el-radio.input(v-model="radioPossuiCar", :label="true", :class="{'erro' : errors.length}") Sim
      el-radio.input(v-model="radioPossuiCar", :label="false", :class="{'erro' : errors.length}") Não
  el-row.labelDiv(v-if="radioPossuiCar || (tipoCadastro && tipoCadastro === 'ONEROSO')" :gutter="30")
    validation-provider(rules="required|reciboCar", v-slot="{ errors }" :name="'Imóvel/Número do Recibo'")
      app-label(label="Número do Recibo do Car:", :required="true" name="Imovel" )
      the-mask.input(
        v-model="cadastroFormulario.imovel.numeroReciboCar"
        class='el-input__inner',
        name="Número do Recibo do Car",
        :mask="['AA-NNNNNNN-FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF']",
        :tokens="tokens",
        :class="{'erro' : errors.length}",
        :masked="true"
      )
      span.help.erro {{ errors[0] }}
  div(v-else)
    el-row.labelDivRow(:guter="30")
      el-col.col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Nome do imóvel'")
          app-label(label="Nome do imóvel:", :required="true" name="Imovel" )
          el-input.input(
            type="text"
            maxlength="300"
            v-model="cadastroFormulario.imovel.nome"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Município'")
          app-label(label="Município:", :required="true" name="Imovel" )
          el-select.input(
            class="select",
            name='Município'
            no-match-text="Nenhum município encontrado",
            placeholder="Selecione",
            v-model="cadastroFormulario.imovel.municipio",
            filterable,
            :class="{'erro' : errors.length}"
            value-key="id"
          )
            el-option(
              v-for="item in municipios",
              :key="item.id",
              :label="item.nome",
              :value="item"
            )
          span.help.erro {{ errors[0] }}
      el-col.col(:span="8")
        validation-provider(rules="required|areaReservaLegal", v-slot="{ errors }" :name="'Imóvel/Área'")
          app-label(label="Área:", :required="true" name="Imovel" )
          el-input.input(
            type="text"
            v-mask-decimal.br="4",
            :maxlength="19",
            v-model="imovelArea"
            :class="{'erro' : errors.length}"
          )
            template(slot="append") hectare(s)
          span.help.erro {{ errors[0] }}
    el-row.labelDivRow(:guter="30")
      el-col.col(:span="24")
        validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Vias de acesso/localização'")
          app-label(label="Vias de acesso/localização:", :required="true" name="Imovel" )
          el-input(
            type="textarea",
            :autosize="{ minRows: 4, maxRows: 8}",
            v-model="cadastroFormulario.imovel.descricaoAcesso",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
  el-row.labelDivRow(:guter="30")
    el-col.col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Há ocupantes anteriores'")
        app-label(label="Há ocupantes anteriores?", :required="true" name="Imovel" )
        el-radio.input(v-model="radioOcupantesAnteriores", :label="true", :class="{'erro' : errors.length}") Sim
        el-radio.input(v-model="radioOcupantesAnteriores", :label="false", :class="{'erro' : errors.length}") Não
        span.help.erro {{ errors[0] }}
    el-col.col(:span="8" v-if="(tipoCadastro && tipoCadastro === 'ONEROSO')")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Possui outros imóveis rurais no Pará'")
        app-label(label="Possui outros imóveis rurais no Pará? ?", :required="true" name="Imovel" )
        el-radio.input(v-model="radioPossuiImovel", :label="true", :class="{'erro' : errors.length}") Sim
        el-radio.input(v-model="radioPossuiImovel", :label="false", :class="{'erro' : errors.length}") Não
        span.help.erro {{ errors[0] }}
    el-col.col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Tempo de ocupação'")
        app-label(label="Tempo de ocupação", :required="true" name="Imovel" )
        .tempo-ocupacao.input
          .select-size
            el-select(
              v-model="cadastroFormulario.imovel.tempoOcupacao",
              filterable,
              placeholder="0",
              size="small",
              name="Tempo Ocupação",
              :class="{'erro' : errors.length}"
            )
              el-option(
                v-for="tempoOcupacao in tempoOcupacaoOptions",
                :key="tempoOcupacao.value",
                :label="tempoOcupacao.label",
                :value="tempoOcupacao.value"
              )
          span {{ cadastroFormulario.imovel.tempoOcupacao == 1 ? 'ano' : 'anos' }}
        span.help.erro {{ errors[0] }}
  el-row.labelDivRow(:guter="30")
    el-col.col(:span="12")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Imóvel/Há conflitos no imóvel'")
        app-label(label="Há conflitos no imóvel?", :required="true" name="Imovel" )
        el-radio.input(v-model="radioHaConflitos", :label="true", :class="{'erro' : errors.length}") Sim
        el-radio.input(v-model="radioHaConflitos", :label="false", :class="{'erro' : errors.length}") Não
        span.help.erro {{ errors[0] }}
    el-col.col(v-if="radioHaConflitos", :span="12")
      app-label(label="Número do Processo Judicial", :required="false" name="Imovel" )
      el-input(v-model="cadastroFormulario.imovel.numeroProcessoJudicial")
  el-row(:gutter="30" v-if="(tipoCadastro && tipoCadastro === 'ONEROSO')" style="margin-top: 20px")
    el-col(:span="24")
      app-documentos-retificacao(
        v-if="tiposDocumentos.length"
        :maxSize='20',
        :valid-extensions="extensoes",
        :documentos="documentosImovel"
        :tiposDocumentos="tiposDocumentos",
        :tiposDocumentosObrigatorios="tiposDocumentosObrigatorios",
        :observer="this.$refs.validation",
        :isDocumentoImagex="true",
        titulo="Documentação",
        aba="Imóvel",
        idUploadDocumento="appUploadDocumentosInteressado",
        @addedDoc="handleDocs",
        @removedDoc="removerDocs"
      )
  el-row(:gutter="30" v-if="(tipoCadastro && tipoCadastro === 'ONEROSO')" style="margin-top: 20px")
    validation-provider(rules="required|termo", v-slot="{ errors }" :name="'Imóvel/termo'")
      el-row(:class="{'erroTermo' : errors.length}")
        el-checkbox(v-model="cadastroFormulario.imovel.termo" :required="true" )
        span &nbsp {{ mensagemFormatada }}
      span.help.erro {{ errors[0] }}
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AppLabel from '@/components/AppLabel'
import axios from '@/utils/api'
import AppDocumentosRetificacao from '@/screens/central/components/cadastro/AppDocumentosRetificacao'
import FileSaver from 'file-saver'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppLabel,
    AppDocumentosRetificacao
  },

  props: ['cadastro', 'observer', 'idProcesso'],

  data () {
    return {
      inputsExtraCadastro,
      documentos: [],
      documentosObrigatorio: [],
      cadastroFormulario: [],
      textoElSelect: 'hectares(s)',
      radioPossuiCar: null,
      radioOcupantesAnteriores: null,
      radioHaConflitos: null,
      radioPossuiImovel: null,
      imovelArea: 0,
      municipios: [],
      tipoCadastro: null,
      tiposDocumentos: [],
      extensoes: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      documentosAlterados: [],
      documentosImovel: null,
      listDocs: null,
      tiposDocumentosObrigatorios: [],
      tokens: {
        A: {
          pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()
        },
        N: {
          pattern: /\d/
        },
        F: {
          pattern: /[0-9a-fA-F]/, transform: v => v.toLocaleUpperCase()
        }
      },
      tempoOcupacaoOptions: []
    }
  },

  async created () {
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.radioPossuiCar = this.cadastroFormulario?.imovel?.possuiCar
    this.radioOcupantesAnteriores = this.cadastroFormulario?.imovel?.ocupantesAnteriores
    this.radioHaConflitos = this.cadastroFormulario?.imovel?.conflitos
    this.radioPossuiImovel = this.cadastroFormulario?.imovel?.possuiImovel
    this.imovelArea = this.formataNumeroToFloatFixed(this.cadastroFormulario.imovel.area)
    this.municipios = await this.getMunicipiosByUf('PA')
    this.tipoCadastro = this.tipo.replace(/['"]/g, '')
    this.tiposDocumentos = await this.findDocumentosByCodigo({
      codigo: 'IMOVEL'
    })
    this.documentosImovel = this.cadastroFormulario?.imovel?.documentos
    this.tiposDocumentosObrigatorios = this.tiposDocumentos.filter(doc => doc.codigo !== 'OUTROS_ONEROSO')
    this.tempoOcupacaoOptions = Array.from(Array(100).keys(), (_, i) => ({
      label: i + 1,
      value: i + 1
    }))

    this.tempoOcupacaoOptions.push({
      value: '100+',
      label: '100+'
    })
  },

  computed: {
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro',
      tipo: 'retificacao/tipo'
    }),
    mensagemFormatada () {
      return this.formatarMensagem()
    }
  },

  methods: {
    ...mapActions('retificacao', ['update']),
    ...mapActions({
      findByIdCadastro: 'cadastro/findCadastroById',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf',
      findDocumentosByCodigo: 'tipoDocumento/findTiposDocumentoByCodigo',
      salvarCadastroRetificacao: 'cadastroRetificacao/salvarCadastroByIdProcesso',
      saveRelDocumentoProcessoRetificacao: 'relDocumentoProcessoRetificacao/saveRelDocumentoProcessoRetificacao',
      baixarDocumento: 'cadastro/downloadDocumentoCentral',
      deleteDocumentoById: 'documentos/deleteDocumentoById'
    }),
    ...mapMutations(
      'retificacao', ['CADASTRO_INICIAL', 'CHANGE_POSSUI_CAR', 'CHANGE_HA_CONFLITOS']
    ),
    formataNumeroToFloatFixed (num) {
      let valor = parseFloat(num)
      return valor.toFixed(4)
    },
    async handleDocs (dados) {
      const doc = {
        id: null,
        _id: dados.id,
        key: dados.fileKey,
        hash: null,
        nome: dados.fileName,
        tipo: dados.tipoDocumento,
        base64: null,
        caminho: null
      }
      this.documentosAlterados.push(doc)
      const newDoc = await this.createDocByKey(doc)
      this.documentosImovel.push(newDoc)
      this.listDocs = [...this.documentosImovel]
      const payload = {
        idDocumento: newDoc.id,
        idProcesso: this.idProcesso
      }
      await this.saveRelDocumentoProcessoRetificacao(payload)
    },

    async removerDocs (doc) {
      if (doc.id) {
        this.documentosAlterados = this.documentosAlterados.filter(item => item.id !== doc.id)
      } else {
        this.documentosAlterados = this.documentosAlterados.filter(item => item.caminho !== doc.fileKey)
      }
      this.listDocs = [...this.documentosImovel.filter(documento => doc.id !== documento.id)]
      if (doc?.id) {
        await this.deleteDocumentoById(doc.id)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },
    async createDocByKey (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/createByKey`,
        data: documento
      })
      return file
    },

    downloadArquivo (arquivo) {
      this.getDownload(arquivo)
    },

    montarJson () {
      const jsonCadastro = {
        tipo: this.tipo,
        versao: this.versao,
        dados: {
          cadastro: this.cadastroFormulario
        }
      }
      return JSON.stringify(jsonCadastro)
    },

    formatarMensagem () {
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      const interessado = this.cadastroFormulario.interessado
      const imovel = this.cadastroFormulario.imovel
      const isCpfOrCnpj = interessado?.pessoa?.isPessoaFisica ? 'CPF' : 'CNPJ'
      const interessadoNomeOrRazaoSocial = interessado?.pessoa?.isPessoaFisica
        ? interessado.pessoa.pessoaFisica.nome
        : interessado.pessoa.pessoaJuridica.razaoSocial
      const cpfOrCnpj = interessado?.pessoa?.isPessoaFisica
        ? interessado.pessoa.pessoaFisica.cpf
        : interessado.pessoa.pessoaJuridica.cnpj
      return `Eu, ${interessadoNomeOrRazaoSocial}, ${isCpfOrCnpj} nº ${cpfOrCnpj},
        DECLARO para os devidos fins, sob as penas da lei, que ocupo imóvel rural identificado neste requerimento do Instituto de Terras do Pará – ITERPA,
        no município de ${interessado.pessoa.endereco.nome},
        tornando-o produtivo há ${imovel.tempoOcupacao} anos,
        e preencho os requisitos estabelecidos na Lei 7.289/2009 e demais normas que a regulamentam.`
    }
  },
  watch: {
    radioPossuiCar (val) {
      this.CHANGE_POSSUI_CAR(val)
      this.update({field: 'imovel.possuiCar', value: val})
    },
    radioOcupantesAnteriores (val) {
      this.update({field: 'imovel.ocupantesAnteriores', value: val})
    },
    radioHaConflitos (val) {
      this.CHANGE_HA_CONFLITOS(val)
      this.update({field: 'imovel.conflitos', value: val})
    },
    'cadastroFormulario.imovel.numeroReciboCar' (val) {
      this.update({field: 'imovel.numeroReciboCar', value: val})
    },
    'cadastroFormulario.imovel.nome' (val) {
      this.update({field: 'imovel.nome', value: val})
    },
    'cadastroFormulario.imovel.municipio' (val) {
      if (val) {
        this.update({field: 'imovel.municipio.estado', value: val?.estado || val?.codigoEstado})
        this.update({field: 'imovel.municipio.nome', value: val.nome})
        this.update({field: 'imovel.municipio.id', value: val.id})
      }
    },
    'imovelArea' (val) {
      if (val) {
        this.update({field: 'imovel.area', value: parseFloat(val.toString().replace(',', '.'))})
      }
    },
    'cadastroFormulario.imovel.descricaoAcesso' (val) {
      this.update({field: 'imovel.descricaoAcesso', value: val})
    },
    'cadastroFormulario.imovel.tempoOcupacao' (val) {
      this.update({field: 'imovel.tempoOcupacao', value: val})
    },
    'cadastroFormulario.imovel.numeroProcessoJudicial' (val) {
      this.update({field: 'imovel.numeroProcessoJudicial', value: val})
    },
    'listDocs' (val) {
      this.update({field: 'imovel.documentos', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      const payload = {
        idProcesso: this.idProcesso,
        cadastro: this.montarJson()
      }
      this.salvarCadastroRetificacao(payload)
    },
    'cadastroFormulario.imovel.termo' (val) {
      this.update({field: 'imovel.termo', value: val})
    }
  }

}
</script>

<style lang="scss" scoped>

.labelDiv {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.erroTermo {
  border: solid 1px red;
  padding: 10px;
}

.labelDivRow {
  display: flex;
  flex-direction: row;
  padding: 20px 0;
}

.col {
  padding: 0 20px 0 0;
}

.inputDiv {
  width: 100%;
}

.selectNacionalidade {
  left: 210px !important;
}

.tempo-ocupacao {
    display: flex;
    align-items: baseline;

    span {
      margin-left: 5px;
    }
  }

  .select-size {
    width: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/Imovel.vue